import React from "react";
import { useState, useEffect } from "react";
import { Form, DrawerProps, Button, Drawer } from "antd";
import { validateFields } from "../../../../../config/Global";
import { assignErrorToInput } from "../../../../../store/api";
import SVGIcon from "../../../../../utils/SVGIcon";
import Config from "../../../../../config/Config";
import { customerAccessCampaignList  } from "../../../CustomerAccess/utils/slice";

import { inviteWebUser } from "../../utils/slice";
// import FormComponent from "./FormComponent";
import { useAppDispatch } from "../../../../../utils/hooks/hooks";
import { formRules } from "../../../../../config/validations/formRules";
import { formatMobileNumber } from "../../../../../utils/commonFunctions";



import { Col, Row, Spin } from "antd";
import { FormBox, InputBox } from "../../../../../components/AntdAddons";
import { rules } from "./rules";


interface AddDrawerProps extends DrawerProps {
  titleName: string;
  close: () => void;
}

/**
 * Renders component for adding a new record to the database for UserManagement module.
 *
 * @param {AddDrawerProps} props - The props for the component.
 * @param {string} props.titleName - The name of the title for the drawer.
 * @param {() => void} props.close - The function to close the drawer.
 * @param {...DrawerProps} props.rest - Additional props for the Drawer component.
 * @return {ReactElement} The rendered component.
 */
const InviteComponent: React.FC<AddDrawerProps> = ({
  titleName,
  close,
  ...rest
}) => {
  const dispatch = useAppDispatch();
  const [customerAccess, setCustomerAccess] = useState([]);
  const [form] = Form.useForm();
  const [disabled, setDisabled] = useState<boolean>(true);
  const [saving, setSaving] = useState<boolean>(false);

  useEffect(() => {
    if (rest?.open && rest.open) {
      setDisabled(true);
      dispatch(customerAccessCampaignList())
        .then((data: any) => {
          setCustomerAccess(data.rows);
          setDisabled(false);
        })
        .catch((error: any) => error);
    }
  }, [rest.open]);


  const drawerClose = () => {
    close();
    form.resetFields();
    setDisabled(true)
  };

  // validate form fields and enable/disable save button based on the result
  const validateForm = () => {
    validateFields(form, setDisabled);
  };

  // handle form submission
  const handleFormSubmit = (data: any) => {

    dispatch(inviteWebUser(data))
      .then(() => {
        drawerClose();
      })
      .catch((error: any) => {
        assignErrorToInput(form, error?.STATUS);
      })
      .finally(() => setSaving(false));
  };

  return (
    <Drawer
      title={`Invite Web ${titleName}`}
      placement="right"
      width={"70%"}
      onClose={drawerClose}
      destroyOnClose
      closeIcon={<SVGIcon icon="close" color={Config.themePrimaryBtn} />}
      footer={[
        <Button
          key="2"
          htmlType="button"
          className="cancelBtn"
          onClick={drawerClose}
        >
          Cancel
        </Button>,
        <Button
          key="1"
          disabled={disabled}
          form="inviteForm"
          loading={saving}
          htmlType="submit"
          type="primary"
        >
          Save
        </Button>,
      ]}
      {...rest}
    >
      <FormBox
        form={form}
        id={'inviteForm'}
        onFinish={(handleFormSubmit)}
        onValuesChange={validateForm}
      >
        <Row gutter={15}>
          <>
            <br />
            <br />
            <Col xs={{ span: 24 }}>
              <b>Invite Details:</b>
            </Col>
            <br />
            <br />
            <Col xs={{ span: 24 }} md={{ span: 12 }}>
              <InputBox.Text
                label="First Name"
                name="name"
                rules={rules.invite_name()}
              />
            </Col>
            <Col xs={{ span: 24 }} md={{ span: 12 }}>
              <InputBox.Text
                label="Last Name"
                name="last_name"
                rules={rules.invite_last_name()}
              />
            </Col>
            <Col xs={{ span: 24 }} md={{ span: 12 }}>
              <InputBox.Text
                label="Mobile Number"
                name="mobile_no"
                maxLength={10}
                placeholder="000-000-0000"
                rules={formRules.mobileNumber()}
                onChange={(e: any) => {
                  if (e.target.value.length > 0) {
                    form.setFieldsValue({
                      mobile_no: formatMobileNumber(e.target.value),
                    });
                  }
                }}
              />
            </Col>
            <Col xs={{ span: 24 }} md={{ span: 12 }}>
              <InputBox.Text
                required
                name="email"
                label="Email"
                rules={rules.email()}
              />
            </Col>
            <Col xs={{ span: 24 }} md={{ span: 12 }} >
              <InputBox.Select
                required
                label="Subscription Name"
                name="campaign_id"
                showSearch
                allowClear
                className="singleSelect"
                optionFilterProp="children"
                filterOption={(input, option: any) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >=
                  0
                }
                options={{
                  list: customerAccess,
                  valueKey: "id",
                  textKey: "campain_name",
                }}
              />
            </Col>
          </>
        </Row>

      </FormBox>
    </Drawer>
  );
};

export default InviteComponent;
